export default function (name, instance) {
  if (process.env.VUE_APP_GLOBAL_INSTANCE_ENABLED) {
    window[name] = instance;
  }
};
